import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Button, Well, Modal } from 'react-bootstrap';
import { ApiStore } from '../../stores/ApiStore';
import { bind, inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';
import Callout from '../site/Callout';
import { VorgangStore } from '../../stores/VorgangStore';

interface IVorlageUebermittelnProps {
  auftragId?: string;
  vorlage: string;
  vorgangId: string;
  text?: string;
  titel?: string;
  uploadText?: string;
  vorgangAbschliessen: boolean;
  onTriggerDocumentRefresh?: () => void;
}

@observer
export default class VorlageUebermitteln extends React.Component<IVorlageUebermittelnProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;
  @inject(UiStore) uiStore: UiStore;

  @observable dokumentStatus: 'nichtVorhanden' | 'angefordert' | 'fehler' | 'erzeugt' = 'nichtVorhanden';
  @observable modalVisible: boolean = false;
  @observable error: string = '';

  @bind @action showModal() {
    this.modalVisible = true;
  }

  @bind @action hideModal() {
    this.modalVisible = false;
  }

  @bind @action setError(value: string) {
    this.error = value;
  }

  @bind @action setzeDokumentStatus(status: 'nichtVorhanden' | 'angefordert' | 'fehler' | 'erzeugt') {
    this.dokumentStatus = status;
  }

  @bind async vorgangAbschliessen() {
    const response = await this.apiStore.vorgangAbschliessen(this.props.vorgangId);
    if (response.ok) {
      return true;
    }
    return false;
  }

  @bind async handleVorlageUebermittelnClick() {
    this.setzeDokumentStatus('angefordert');
    const { auftragId, vorgangId, vorlage } = this.props;

    const response =
      (vorlage.indexOf('vermessung_kalibrierschein') > -1)  ?
      await this.apiStore.beurteilungaufstellflaecheKalibrierschein(vorgangId, auftragId) :
      await this.apiStore.vorgangVorlageErzeugen(vorgangId, vorlage);

    if (response.ok) {
      // Optional kann der Vorgang nach dem erfolgreichen Erzeugen des Dokuments direkt abgeschlossen werden
      this.setzeDokumentStatus('erzeugt');
      if (this.props.vorgangAbschliessen) {
        await this.vorgangAbschliessen();
        this.uiStore.navigateTo(`vorgang/${this.props.vorgangId}`);
      } else {
        // Wenn der Vorgang nicht abgeschlossen werden soll, wird die Liste der Dokumente im Vorgang aktualisiert
        if (this.props.onTriggerDocumentRefresh) {
          this.props.onTriggerDocumentRefresh();
        }
      }
    } else {
      if (response.error) {
        this.setzeDokumentStatus('fehler');
        this.setError(response.error);
        this.showModal();
      }
    }

  }

  render() {
    return (
      <div>
        <h3>
          <a name="#dokumente"/>Daten übermitteln
        </h3>

        <Callout bsStyle="warning">
        <h4>{this.props.titel ? this.props.titel : 'Vorlage erzeugen'}</h4>
          <div>
            {(this.props.text == null) && <p>Übermittelt die gespeicherten Daten zur Bearbeitung an die DIQ Zert.</p>}
            {(this.props.text != null) && <div dangerouslySetInnerHTML={{__html: this.props.text}}/>}
            {this.dokumentStatus === 'angefordert' &&
              <Well bsSize="small" bsStyle="info">
                Daten werden übermittelt...
              </Well>
            }
            {this.dokumentStatus === 'erzeugt' &&
              <Well bsSize="small" bsStyle="success">
                Das vorläufige Dokument wurde übermittelt.
                {this.props.uploadText && <div>{this.props.uploadText}</div>}
              </Well>
            }
          </div>
          <div className="text-right">
            <Button bsStyle="primary" onClick={this.handleVorlageUebermittelnClick} disabled={this.dokumentStatus === 'angefordert'}>Daten übermitteln</Button>
          </div>
        </Callout>

        <Modal show={this.modalVisible} onHide={this.hideModal} className="modal-vertical-centered error" backdrop={'static'}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Fehler</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>Beim Übermitteln der Daten ist ein Fehler aufgetreten:</div>
            <div className="modal-error-msg">{this.error}</div>
            <div>Bitte übermitteln Sie die Daten erneut. Sollte der Fehler weiterhin auftreten, wenden Sie sich bitte mit obiger Fehlermeldung an die DIQ Zert.</div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideModal} bsStyle="default">Schließen</Button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorlageUebermitteln.tsx